<template>
	<div class="container">
	<div v-show="loading" class="loading">
      <i  class="fa fa-3x fa-spinner fa-spin"></i>
    </div>
		<div class="row">
			<div class="col-md-12">
				<div class="widget-wrap">
					<div class="widget-container margin-top-0">
						<div class="widget-content">
							<div class="row  w-section-header">
								<h1>Register a new product</h1>
							</div>
							<div class="j-forms j-multistep">
								<div class="wizard-breadcrumb number-style">
									<div class="row">
										<div class="col-xs-4 step" v-bind:class="{ 'active-step': step1 }">
											<div class="steps">
												<span class="step-number">1</span>
												<p>Add License key or Redeem code</p>
											</div>
										</div>
										<div class="col-xs-4 step" v-bind:class="{ 'active-step': step2 }">
											<div class="steps">
												<span class="step-number">2</span>
												<p>Check email</p>
											</div>
										</div>
										<div class="col-xs-4 step" v-bind:class="{ 'active-step': step3 }">
											<div class="steps">
												<span class="step-number">3</span>
												<p>Done</p>
											</div>
										</div>
									</div>
								</div>
								<div class="row" v-if="addOrderErr">
									<div class="col-sm-6 col-sm-offset-3 unit">
										<div class="error-message">
											<i class="fa fa-close"></i>
											<p>{{ addOrderErr }}</p>
										</div>
									</div>
								</div>
								<!-- step 1 -->
								<fieldset class="active-fieldset" v-if="step1">
									<!--<div class="col-sm-6 col-sm-offset-3 unit">
                                        <div class="inline-group">
                                            <h3>You've a</h3>
                                            <label class="radio">
                                                <input type="radio" v-model="myCode" checked="" value="licenseKey" id="licensekey">
                                                <i></i>
                                                License key
                                            </label>
                                            <label class="radio">
                                                <input type="radio" v-model="myCode" value="requestCode" id="requestcode">
                                                <i></i>
                                                Redeem code
                                            </label>
                                        </div>
									</div>-->

									<!-- license key -->
									<!--<div v-if="myCode == 'licenseKey'">	-->
										<div class="col-sm-6 col-sm-offset-3 unit">
											<div class="input">
												<label class="icon-right" for="name">
													<i class="fa fa-key"></i>
												</label>
												<input type="text" v-model="lKey" v-on:input="addOrderErr=null" class="form-control" placeholder="Enter your License key or Redeem code" autofocus>
											</div>
										</div>
										<div class="col-xs-12">
											<p>If you have multiple licenses, insert the first license key. If you have multiple redeem codes, repeat the process for each.</p>
										</div>
									<!--</div>-->

									<!-- redeem code -->
									<!--<div v-if="myCode == 'requestCode'">
										<div class="col-sm-6 col-sm-offset-3 unit">
											<div class="input">
												<label class="icon-right" for="name">
													<i class="fa fa-keyboard-o"></i>
												</label>
												<input type="text" v-model="rCode" class="form-control" placeholder="Enter your Redeem code" autofocus>
											</div>
										</div>
										<div class="col-xs-12">
											<p>If you have multiple redeem codes, repeat the process for each</p>
										</div>
									</div>-->

								</fieldset>

								<!-- step 2 -->
								<fieldset class="active-fieldset" v-if="step2">
									<div class="col-xs-12 unit">
										<i class="zmdi zmdi-hc-5x zmdi-email"></i>
										<h3>You've got a mail, check {{ email }}</h3>
									</div>
								</fieldset>

								<!-- step 3 -->
								<fieldset class="active-fieldset" v-if="step3">
									<div class="col-xs-12 unit">
										<i class="zmdi zmdi-hc-5x zmdi-thumb-up"></i>
										<h3>Well done!</h3>
									</div>
								</fieldset>

								<div class="form-footer block-form-footer">
									<button v-if="step1" type="button" class="btn btn-primary primary-btn multi-next-btn" @click="addKey()">Next</button>
									<button v-if="this.addOrderErr !== ''" type="button" class="btn btn-primary primary-btn multi-next-btn" @click="resetKey()">Reset</button>
									<button v-if="step2" type="button" class="btn btn-primary primary-btn processing">Waiting...</button>
									<a v-if="step3" href="/"><button type="button" class="btn btn-success primary-btn multi-next-btn">Done</button></a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script type="text/javascript">
	import auth from '../auth'

	export default {
		data(){
			return{
				addOrderErr:'',
				step1:true,
				step2:false,
				step3:false,
				email:'',
				lKey: null,
				rCode: null,
				myCode: 'licenseKey',
				loading: false
			}
		},
		methods: {
		  resetKey(){
        this.addOrderErr = ''
        this.lKey = null
        localStorage.removeItem('promo')
      },
			addKey(){
				/*if (this.myCode == 'licenseKey'){
					if (this.lKey){
						auth.assignTransaction(this, this.lKey)
					}
				}else{
					if (this.rCode){
						auth.assignTransactionRc(this, this.rCode)
					}
				}*/
        this.addOrderErr = ''
        auth.assignTransactionRc(this, this.lKey)
			},

		},
    mounted: function () {
    	console.log(this.$route.params)
      if (this.$route.query.redeem_code){
        this.lKey = this.$route.query.redeem_code
        auth.assignTransactionRc(this, this.lKey)
      }
      else if(this.$route.params.redeem_code){
				this.lKey = this.$route.params.redeem_code
				auth.assignTransactionRc(this, this.lKey)
			} else if(localStorage.getItem('promo_redeem_code')){
				this.lKey = localStorage.getItem('promo_redeem_code')
				auth.assignTransactionRc(this, this.lKey)
			}

		    this.$nextTick(function () {
				if(localStorage.getItem('status2')){
					this.step2 = true
					this.step1 = false
					this.step3 = false
					localStorage.removeItem('status2')
				}
		    })

		    this.$analytics.fbq.event('PageView')


		},
		watch:{
	      step2: function(val){
	      	this.addOrderErr = null
	      	var context = this
	        if (val == true){
	        	var intervalID = window.setInterval(checkMail, 5000);
	        	function checkMail(){
		        		auth.checkTrans(context)
	        		}
	        	}
	        },
      '$route.query.redeem_code': {
        handler: function(val){
          if(typeof val !== 'undefined'){
            this.lKey = this.$route.query.redeem_code
            auth.assignTransactionRc(this, this.lKey)
            localStorage.removeItem('promo')
          }
        },
        deep: true,
        immediate: true
      }
	      }
	    }
</script>



// WEBPACK FOOTER //
// src/components/Addorder.vue